(() => {
  'use strict';
  const t = (text, params) => window.LRSI18n?.t(text, params) ?? String(text).replace(/\{(\w+)\}/g, (match, key) => params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
  if (window.LRSDetailZoom) return;
  const dialog = document.querySelector('#lightbox');
  const viewport = dialog?.querySelector('[data-detail-viewport]');
  const image = dialog?.querySelector('#lightbox-image');
  if (!dialog || !viewport || !image) return;
  const out = dialog.querySelector('[data-detail-zoom-out]');
  const into = dialog.querySelector('[data-detail-zoom-in]');
  const resetButton = dialog.querySelector('[data-detail-reset]');
  const value = dialog.querySelector('[data-detail-zoom-value]');
  const message = dialog.querySelector('[data-detail-message]');
  const pointers = new Map();
  const MIN = 1, MAX = 4;
  let scale = MIN, x = 0, y = 0, loaded = false, gesture = null;

  function box() { return viewport.getBoundingClientRect(); }
  function local(clientX, clientY) {
    const rect = box();
    return {x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2};
  }
  function maximum() {
    const rect = box();
    if (!image.naturalWidth || !image.naturalHeight || rect.width <= 0 || rect.height <= 0) return MAX;
    const fit = Math.min(rect.width / image.naturalWidth, rect.height / image.naturalHeight);
    // Respect the original resolution, with a gentle 1.5× inspection of smaller samplers.
    return Math.max(1.5, Math.min(MAX, 1 / fit));
  }
  function clampPan() {
    const rect = box();
    if (rect.width <= 0 || rect.height <= 0) { x = 0;y = 0;return; }
    const width = image.naturalWidth || rect.width;
    const height = image.naturalHeight || rect.height;
    const fit = Math.min(rect.width / width, rect.height / height);
    const limitX = Math.max(0, (width * fit * scale - rect.width) / 2);
    const limitY = Math.max(0, (height * fit * scale - rect.height) / 2);
    x = Math.max(-limitX, Math.min(limitX, x));
    y = Math.max(-limitY, Math.min(limitY, y));
  }
  function paint() {
    scale = Math.min(scale, maximum());
    clampPan();
    image.style.transform = `translate3d(${x}px,${y}px,0) scale(${scale})`;
    viewport.classList.toggle('is-zoomed', scale > MIN + .001);
    value.textContent = `${Math.round(scale * 100)}%`;
    out.disabled = !loaded || scale <= MIN + .001;
    into.disabled = !loaded || scale >= maximum() - .001;
    resetButton.disabled = !loaded || scale <= MIN + .001;
  }
  function releasePointers() {
    pointers.forEach((_, id) => {
      try { if (viewport.hasPointerCapture?.(id)) viewport.releasePointerCapture(id); } catch (_) { /* Pointer was already released. */ }
    });
    pointers.clear();gesture = null;viewport.classList.remove('is-dragging');
  }
  function reset() { releasePointers();scale = MIN;x = 0;y = 0;paint(); }
  function setZoom(next, focal = {x: 0, y: 0}) {
    if (!loaded) return;
    const target = Math.max(MIN, Math.min(maximum(), next));
    const ratio = target / scale;
    x = focal.x - (focal.x - x) * ratio;
    y = focal.y - (focal.y - y) * ratio;
    scale = target;paint();
  }
  function status(state) {
    viewport.classList.toggle('is-loading', state === 'loading');
    viewport.classList.toggle('is-error', state === 'error');
    viewport.setAttribute('aria-busy', String(state === 'loading'));
    message.hidden = state === 'ready' || state === 'closed';
    message.textContent = t(state === 'error' ? 'This photograph could not be loaded. Please choose another image.' : state === 'loading' ? 'Loading photograph…' : '');
  }
  function prepare() { loaded = false;reset();status('loading'); }
  function imageReady() {
    if (!image.naturalWidth) return;
    loaded = true;status('ready');paint();
  }
  function beginGesture() {
    const points = [...pointers.values()];
    if (points.length >= 2) {
      const [a, b] = points;
      gesture = {type: 'pinch', distance: Math.max(1, Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY)),
        center: local((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2), scale, x, y};
    } else if (points.length === 1) gesture = {type: 'pan', clientX: points[0].clientX, clientY: points[0].clientY, x, y};
    else gesture = null;
  }
  dialog.addEventListener('lrs:lightbox:imagechange', prepare);
  image.addEventListener('load', imageReady);
  image.addEventListener('error', () => { loaded = false;reset();status('error'); });
  dialog.addEventListener('close', () => { loaded = false;reset();status('closed'); });
  into.addEventListener('click', () => setZoom(scale * 1.5));
  out.addEventListener('click', () => setZoom(scale / 1.5));
  resetButton.addEventListener('click', reset);
  viewport.addEventListener('dragstart', event => event.preventDefault());
  viewport.addEventListener('dblclick', event => {
    if (!loaded) return;
    event.preventDefault();setZoom(scale > MIN + .001 ? MIN : 2.5, local(event.clientX, event.clientY));
  });
  viewport.addEventListener('wheel', event => {
    if (!dialog.open || !loaded) return;
    event.preventDefault();
    const pixels = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? box().height : 1);
    setZoom(scale * Math.exp(-Math.max(-120, Math.min(120, pixels)) * .003), local(event.clientX, event.clientY));
  }, {passive: false});
  viewport.addEventListener('pointerdown', event => {
    if (!dialog.open || !loaded || (event.pointerType === 'mouse' && event.button !== 0)) return;
    viewport.focus({preventScroll: true});
    pointers.set(event.pointerId, {clientX: event.clientX, clientY: event.clientY});
    try { viewport.setPointerCapture?.(event.pointerId); } catch (_) { /* Capture is optional. */ }
    beginGesture();
    viewport.classList.toggle('is-dragging', scale > MIN || pointers.size > 1);
  });
  viewport.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    pointers.set(event.pointerId, {clientX: event.clientX, clientY: event.clientY});
    const points = [...pointers.values()];
    if (gesture.type === 'pinch' && points.length >= 2) {
      const [a, b] = points;
      const distance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
      const center = local((a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
      scale = Math.max(MIN, Math.min(maximum(), gesture.scale * distance / gesture.distance));
      x = center.x - (gesture.center.x - gesture.x) * scale / gesture.scale;
      y = center.y - (gesture.center.y - gesture.y) * scale / gesture.scale;
      paint();
    } else if (gesture.type === 'pan' && scale > MIN) {
      x = gesture.x + event.clientX - gesture.clientX;
      y = gesture.y + event.clientY - gesture.clientY;
      paint();
    }
  });
  function pointerEnd(event) {
    if (!pointers.has(event.pointerId)) return;
    pointers.delete(event.pointerId);
    try { if (viewport.hasPointerCapture?.(event.pointerId)) viewport.releasePointerCapture(event.pointerId); } catch (_) { /* Already released. */ }
    beginGesture();viewport.classList.toggle('is-dragging', pointers.size > 0 && scale > MIN);
  }
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => viewport.addEventListener(name, pointerEnd));
  document.addEventListener('keydown', event => {
    if (!dialog.open || event.altKey || event.metaKey || event.ctrlKey || event.target.closest?.('input,textarea,select,[contenteditable="true"]')) return;
    if (event.key === '+' || event.key === '=') { event.preventDefault();setZoom(scale * 1.5); }
    else if (event.key === '-') { event.preventDefault();setZoom(scale / 1.5); }
    else if (event.key === '0' || event.key === 'Home') { event.preventDefault();reset(); }
    else if (scale > MIN && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
      event.preventDefault();
      const distance = event.shiftKey ? 120 : 55;
      if (event.key === 'ArrowLeft') x += distance;
      if (event.key === 'ArrowRight') x -= distance;
      if (event.key === 'ArrowUp') y += distance;
      if (event.key === 'ArrowDown') y -= distance;
      paint();
    }
  });
  window.addEventListener('resize', () => { if (dialog.open) { releasePointers();paint(); } }, {passive: true});
  window.addEventListener('blur', releasePointers);
  document.addEventListener('visibilitychange', () => { if (document.hidden) releasePointers(); });
  document.addEventListener('shopify:section:unload', event => {
    if (dialog.open && event.target.querySelector('[data-gallery]')) dialog.close();
  });
  // All movement follows the user's input directly; no inertial or automatic motion.
  window.LRSDetailZoom = {reset, isZoomed: () => scale > MIN + .001};
  if (image.complete && image.naturalWidth) imageReady();
  else paint();
})();
